import { SxProps, Theme } from "@mui/material";

export default (theme: Theme): Record<string, SxProps<Theme> | ((isActive: boolean) => SxProps<Theme>)> => ({
  stepper: {
    gap: "var(--rhythm)",
    mt: "var(--rhythm)",
    counterReset: "stepper",
  },
  step: {
    "&:hover": {
      "& .MuiStepIcon-root": {
        color: "var(--color-primary)",
      },
    },
  },
  icon: {},
  label: (isActive: boolean): SxProps<Theme> => ({
    padding: "calc(0.5 * var(--rhythm)) 0",
    paddingLeft: "var(--rhythm)",
    borderLeft: isActive ? "4px solid var(--color-primary)" : "4px solid transparent",
    "& .MuiStepLabel-labelContainer": {},
    "& .MuiStepLabel-label": {
      fontSize: "var(--font-size-xs)",
      fontWeight: isActive ? 800 : 400,
      color: isActive ? "var(--color-primary)" : "var(--color-black)",
      "&::before": {
        content: "counter(stepper) '.' ", // Disable this line in order to use icons
        counterIncrement: "stepper",
        display: "inline-block",
        mr: "1ex",
      },
    },
    "& .MuiStepLabel-iconContainer": {
      display: "none",  // Disable this line in order to use icons
      color: "red",
      "& .MuiStepIcon-root": {
        width: "var(--rhythm)",
        height: "var(--rhythm)",
        color: "var(--color-grey)",
      },
      "&.Mui-active .MuiStepIcon-root": {
        color: "var(--color-primary)",
      },
    },
    [theme.breakpoints.down("md")]: {
      paddingLeft: "var(--rhythm)",
    },
  }),
});
